import {css} from 'styled-components';

import {msi} from '../normalizeSize';

export const square = (
  value: number,
  {
    min,
    ms,
  }: {
    min?: boolean;
    ms?: boolean;
  } = {
    min: true,
    ms: true,
  },
) => {
  const size = ms ? msi(value) : value;

  const result = css`
    width: ${size}px;
    height: ${size}px;

    ${min &&
    css`
      min-width: ${size}px;
      min-height: ${size}px;
    `}
  `;

  return result;
};
